import List from "@/components/list";
import { tableBaseProps } from "@/utils/common.js";

const Table = (args) => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const editRoomNumber = listeners["editRoomNumber"] || function () { };
  const delLiaison = listeners["delLiaison"] || function () { };
  const { isConvene = false, onlyLook = false } = props

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const dealConf = [
      [
        "iconfont icxiugaifangjianhao iconfont-adapt",
        "修改房间号",
        () => {
          editRoomNumber(vo);
        },
        "liaison:user:update",
      ],
      [
        "icon-delete",
        "删除",
        () => {
          delLiaison(vo);
        },
        "liaison:user:delete",
      ],
    ];

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    tableBaseProps("姓名", "userName", "100"),
    tableBaseProps("单位及职务", "unitPosition", "m100"),
    tableBaseProps("房间号", "roomNumber", "m60"),
  ];

  AccountTableConfig.push({
    label: "操作",
    fixed: "right",
    width: 80,
    render: (vo) => <Deal vo={vo} />,
  });
  
  if (onlyLook) {
    AccountTableConfig.shift();
    AccountTableConfig.pop();
  }

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
